import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '娱乐圈黑料', path: '/category/yulequan' },
  { name: '主播塌房', path: '/category/zhubo' },
  { name: '网红八卦', path: '/category/wanghong' },
  { name: '社会热点', path: '/category/shehui' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="font-heading text-2xl text-primary-500">🍉</span>
            <span className={`font-heading text-xl font-bold transition-colors duration-300 ${scrolled ? 'text-foreground-950' : 'text-white'}`}>
              黑料吃瓜在线
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link, i) => (
              <span key={link.path} className="flex items-center">
                {i > 0 && (
                  <span className={`mx-1 text-xs transition-colors duration-300 ${scrolled ? 'text-secondary-400' : 'text-white/40'}`}>◆</span>
                )}
                <Link
                  to={link.path}
                  className={`px-3 py-2 text-sm font-medium rounded-md transition-all duration-200 whitespace-nowrap hover:bg-background-200/50 ${
                    location.pathname === link.path
                      ? scrolled
                        ? 'text-primary-500'
                        : 'text-white'
                      : scrolled
                        ? 'text-foreground-700 hover:text-foreground-950'
                        : 'text-white/80 hover:text-white'
                  }`}
                >
                  {link.name}
                </Link>
              </span>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                scrolled
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-white/20 text-white border border-white/30 hover:bg-white/30 backdrop-blur-sm'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors duration-200 cursor-pointer ${
              scrolled ? 'text-foreground-950' : 'text-white'
            }`}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/60">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-3 rounded-lg text-sm font-medium transition-colors duration-150 ${
                  location.pathname === link.path
                    ? 'text-primary-500 bg-primary-50'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="mt-2 px-3 py-3 rounded-lg text-sm font-medium bg-primary-500 text-white text-center hover:bg-primary-600 transition-colors duration-150"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}